<template>
  <v-card>
    <v-card-text>
      <div v-if="selected.length > 0" class="mb-3">
        <template v-for="(item, index) in selected">
          <div :key="index">
            <v-chip label color="primary" text-color="white" close @input="handleRemove(index)">{{
              item.title
            }}</v-chip>
            <em v-if="index + 1 < selected.length" class="fas fa-chevron-right mx-1" />
          </div>
        </template>
      </div>
      <!-- 
      <div class="my-3">
        <v-text-field
          v-model="search"
          prepend-inner-icon="search"
          outline
          type="text"
          :placeholder="$t('Search')"
          class="default-input"
          maxlength="255"
          name="search"
          hide-details
        />
      </div> -->
      <div v-if="currentWrapUpOptions.length > 0">
        <v-list class="py-0">
          <template v-for="(item, index) in currentWrapUpOptions">
            <WrapUpParent
              :key="index"
              :item="item"
              active-class="grey lighten-4 indigo--text"
              style="border: 1px solid #eee"
              class="mb-2"
              @onClick="handleSelectedOption(item)"
            >
            </WrapUpParent>
          </template>
        </v-list>
      </div>
      <div v-else class="my-4 text-xs-center">{{ $t('No data') }}</div>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="grey" outline @click="onCancel">{{ $t('cancel') }}</v-btn>
      <v-btn color="primary" @click="onSave">{{ $t('Save') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import WrapUpParent from './WrapUpParent'
export default {
  components: {
    WrapUpParent
  },
  props: ['value', 'wrapUpOptions'],
  data() {
    return {
      selected: [],
      currentWrapUpOptions: [],
      search: ''
    }
  },
  computed: {
    // wrapUpData() {
    //   return this.$store.state.wrapUp
    // },
    // filterOptions() {
    //   let options = []
    //   if (this.search) {
    //     options = this.wrapUpOptions.filter((option) =>
    //       option.toLowerCase().includes(this.search.toLowerCase())
    //     )
    //   } else {
    //     options = this.wrapUpOptions
    //   }
    //   return options
    // },
    // currentSelected() {
    //   return this.selected
    // }
  },

  async mounted() {
    this.selected = [...this.value]
    this.handleSetWrapUpOptions()
  },
  methods: {
    onCancel() {
      this.$emit('onClose')
    },
    onSave() {
      this.$emit('onSave', this.selected)
      this.$emit('onClose')
    },
    handleSetWrapUpOptions() {
      if (this.value.length > 0) {
        const temp = this.handleFindWrapUpOptions(this.wrapUpOptions, 0, this.selected)
        this.currentWrapUpOptions = temp
      } else {
        this.currentWrapUpOptions = this.wrapUpOptions
      }
    },
    handleFindWrapUpOptions(wrapUpOptions, level, value) {
      // find the current level wrap up options
      if (value.length == 0) {
        return wrapUpOptions
      } else if (!value[level]) {
        return false
      } else {
        const result = wrapUpOptions.find((option) => {
          return option.level == level && option.title === value[level].title
        })
        if (result && result.subWrapUp.length > 0) {
          const subWrapUp = this.handleFindWrapUpOptions(result.subWrapUp, level + 1, value)

          if (subWrapUp) {
            return subWrapUp
          } else {
            return result.subWrapUp
          }
        } else {
          return false
        }
      }
    },
    handleSelectedOption(value) {
      let result = {}
      result = {
        type: 'level',
        title: value.title,
        level: value.level
      }
      this.currentWrapUpOptions = value.subWrapUp

      this.selected = [...this.selected, result]
    },
    async handleRemove(index) {
      // remove from index to end
      const val = [...this.value]
      if (val.length === 1) {
        this.selected = []
      } else {
        val.splice(index)
        this.selected = val
      }
      await this.$nextTick()
      this.handleSetWrapUpOptions()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/WrapUpInput/WrapUpDialog.vue